var tabs, imgs, videos, currentMerch=1;

/* Кликнул на таб в Альфе*/
function handleTab(e) {
    for (var i = 0; i < tabs.length; i++) {
        if (e.target != tabs[i]) {
            removeClass(tabs[i], 'active');
            removeClass(imgs[i], 'active');
        } else {
            addClass(tabs[i], 'active');
            addClass(imgs[i], 'active');
        }
    }
}

/*
 Объект виден в области окна
 */
function isInViewport(el) {
    var bounding = el.getBoundingClientRect(),
        h        = parseFloat(getComputedStyle(el, null).height.replace("px", ""));

    return (
        bounding.top > 50 - h &&
        bounding.bottom < (window.innerHeight || document.documentElement.clientHeight) + h - 50
    );
}

/*
 Показать видео клиента
 */
function clientVideo() {
    var videos = document.querySelectorAll(".client-video video");

    Array.prototype.forEach.call(videos, function (el, i) {
        var parent = el.parentNode;

        if (!isInViewport(el)) {
            parent.classList.remove('inview');

            if (el.currentTime == el.duration) {
                parent.classList.remove('inplay');
            }

            return;
        } else {
            parent.classList.add('inview');
        }

        if (parent.classList.contains('inplay')) {
            return;
        } else {
            parent.classList.add('inplay');
        }

        if (!parent.classList.contains('loaded')) {
            loadVideo(i, 'client');
        } else {
            el.currentTime = 0;
            el.play();
        }
    });
}

/*
 Показать видео на главной
 */
function mainVideo() {
    var w = document.documentElement.clientWidth;
    var h = document.documentElement.clientHeight;
    var height = document.documentElement.clientWidth * (h > w ? 1.614864864864865 : 0.4322916666666667);

    var videos = document.querySelectorAll(".main-video-section");
    Array.prototype.forEach.call(videos, function (el) {
        el.style.height = height + 'px';
    });

    videos = document.querySelectorAll(".main-video video");
    Array.prototype.forEach.call(videos, function (el, i) {
        loadVideo(i, 'main');
    });
}

/*
 * Загрузить видео
 */
function loadVideo(i, type) {
    var videos = document.querySelectorAll("." + type + "-video"),
        el     = videos[i],
        url    = el.dataset.source,
        // w      = parseFloat(getComputedStyle(el, null).width.replace("px", "")),
        // h      = parseFloat(getComputedStyle(el, null).height.replace("px", "")),
        video  = document.createElement('video'),
        source = document.createElement('source');

    source.src  = url + (screen.height > screen.width ? '-square' : '') + '.mp4?v=1';
    source.type = 'video/mp4';

    video.autoplay    = true;
    video.muted       = true;
    video.playsinline = true;

    // video.setAttribute('poster', url + (h > w ? '-square' : '') + '-thumb.jpg?v=1');
    video.setAttribute('autoplay', "");
    video.setAttribute('muted', "");
    video.setAttribute('playsinline', "");

    video.append(source);

    if (type === 'main') {
        video.loop = true;
        video.setAttribute('loop', "");

        video.addEventListener("canplaythrough", function () {
            video.play()
        }, true);
    } else {
        video.addEventListener("ended", function () {
            if (!isInViewport(video)) {
                removeClass(el, 'inplay');
            }
        }, true);
    }

    video.addEventListener("canplay", function () {
        video.play();
        addClass(el, 'inplay');
    }, true);

    el.removeChild(el.firstElementChild);
    el.append(video);
    addClass(el, 'loaded');
}

/*
 * Скролл для мерчендайзинга
 */
function scrollMerch() {
    var wrap  = document.querySelector('.main-merch-wrap'),
        left  = document.querySelector('.main-merch-btn.left'),
        right = document.querySelector('.main-merch-btn.right');

    right.addEventListener('click', function() {
         if (currentMerch < 3) currentMerch++; else return;
         sideScroll(wrap,'right',15,window.innerWidth,30);
         checkScrollButtons(wrap, left, right);
    });

    left.addEventListener('click', function() {
        if (currentMerch > 1) currentMerch--; else return;
        sideScroll(wrap,'left',15,window.innerWidth,30);
        checkScrollButtons(wrap, left, right);
    });

    checkScrollButtons(wrap, left, right);
}

function checkScrollButtons(wrap, left, right) {
    if (currentMerch > 1) {
        addClass(left, 'active');
    } else {
        removeClass(left, 'active');
    }

    if (currentMerch < 3) {
        addClass(right, 'active');
    } else {
        removeClass(right, 'active');
    }
}

// слайд елемента
function sideScroll(element, direction, speed, distance, step){
    scrollAmount = 0;
    var slideTimer = setInterval(function(){
        if(direction == 'left'){
            element.scrollLeft = element.scrollLeft - step;
        } else {
            element.scrollLeft = element.scrollLeft + step;
        }
        scrollAmount += step;

        if(scrollAmount >= distance){
            window.clearInterval(slideTimer);
        }
    }, speed);
}

ready(function() {
    tabs = document.querySelectorAll('.alfa-branding-tab');
    imgs = document.querySelectorAll('.alfa-branding-img');

    for (var i = 0; i < tabs.length; i++) {
        tabs[i].addEventListener('click', handleTab);
    }

    MediaBox('.brand-video');

    // Видео клиентов
    if (document.querySelectorAll(".client-video video").length) {
        document.addEventListener('DOMContentLoaded', clientVideo, false);
        document.addEventListener('scroll', clientVideo, false);
    }

    // Видео на главной
    if (document.querySelectorAll(".main-video video").length) {
        document.addEventListener('DOMContentLoaded', mainVideo, false);
        // window.addEventListener('resize', mainVideo); // Look at the missing parentheses.
        // window.addEventListener('orientationchange', mainVideo);
    }

    // скролл для блока Мерчендайзинг
    if (document.querySelectorAll(".main-merch-btn").length) {
        scrollMerch();
    }
});
